<template>
  <div class="container">
    <div class="columns">
      <div class="column box is-three-fifths is-offset-one-fifth content">
        <div class="section has-text-left">
          <h2
            class="has-text-centered  m-b-sm"
            v-text="$wording.register.form_1"
          />
          <router-link
            class="m-b-md has-text-centered is-block"
            :to="{ name: 'login' }"
          >
            If you already have an account, log in.
            <i
              class="fas fa-arrow-circle-right"
              aria-hidden="true"
            />
          </router-link>
          <p class="m-b-lg">
            <span v-html="$wording.register.form_2" /><a
              @click.prevent="showTermsAndConditions"
            >{{ $wording.register.form_3 }}.</a>
          </p>
          <profile-form />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileForm from '@/components/ProfileForm';
export default {
  name: 'Register',
  components: {
    ProfileForm,
  },
};
</script>

<style lang="scss" scoped>
</style>